import {
  useHovercardDescription
} from "../__chunks/ROOVOZJF.js";
import "../__chunks/SRHDWRFI.js";
import "../__chunks/YSASCXX3.js";
import "../__chunks/LNHZLQEK.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/menu/menu-description.ts
var useMenuDescription = createHook(
  (props) => {
    props = useHovercardDescription(props);
    return props;
  }
);
var MenuDescription = createComponent(
  (props) => {
    const htmlProps = useMenuDescription(props);
    return createElement("p", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  MenuDescription.displayName = "MenuDescription";
}
export {
  MenuDescription,
  useMenuDescription
};
